import React from 'react';
import T from 'prop-types';

const ChartCaptions = ({ data }) => (
  <div className="chart-captions">
    {data.map((item, index) => (
      <div key={index} className="chart-captions__item">
        <h6 className="chart-captions__item-title">{item.header}</h6>
        <div
          className="chart-captions__item-description"
          dangerouslySetInnerHTML={{
            __html: item.desc,
          }}
        />
      </div>
    ))}
  </div>
);

ChartCaptions.propTypes = {
  data: T.arrayOf(
    T.shape({
      header: T.string,
      desc: T.string,
    })
  ).isRequired,
};

export default ChartCaptions;
